import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Seo from "./components/Seo";

// import all your pages
import Home from "./pages/Home";
import Developers from "./pages/Developers";
import AboutUs from "./pages/AboutUs";
import Pricing from "./pages/Pricing";
import Remittance from "./pages/Remittance";
import QrPayment from "./pages/QrPayment";
import ArifEqub from "./pages/ArifEqub";
import EInvoice from "./pages/EInvoice";
import SmartPos from "./pages/SmartPos";
import MobilePos from "./pages/MobilePos";
import Msmes from "./pages/Msmes";
import Retail from "./pages/Retail";
import Hospitality from "./pages/Hospitality";
import Transportation from "./pages/Transportation";
import ContactUs from "./pages/ContactUs";
import Partner from "./pages/Partners";
import BecomeAPartner from "./pages/BecomeAPartner";
import PaymentGatewaySection from "./pages/Gateway";
import MerchantApp from "./pages/MerchantApp";
import BecomeAMerchantSection from "./pages/Merchant1";
import PressandRelesa from "./pages/PressRelease";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetal1";
import Jobs from "./pages/Jobs";
import Corporate from "./pages/Corporate";
import CorporateJob from "./pages/corporate1";
import Pagination from "./pages/Pagination";
import Integrate from "./pages/gatewayIntegration";
import Wallet from "./pages/Wallet";
import CarParking from "./pages/CarParking";
import CompanyProfileViewer from "./pages/CompanyProfileViewer";
import Ecommerce from "./pages/Ecommerce";
import HealthCare from "./pages/HealthCare";
import EventDetailFoundersFriday from "./pages/EventDetailFoundersFriday.jsx";
import UpcomingEventPage from "./pages/UpcommingEvent.jsx";
import Job from "./pages/Job.jsx";
import Compliance from "./pages/Compliance.jsx";

function App() {
  return (
    <>
      <Seo />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Developers" element={<Developers />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/Gateway" element={<PaymentGatewaySection />} />
        <Route path="/Remittance" element={<Remittance />} />
        <Route path="/SmartPos" element={<SmartPos />} />
        <Route path="/MobilePos" element={<MobilePos />} />
        <Route path="/Msmes" element={<Msmes />} />
        <Route path="/Retail" element={<Retail />} />
        <Route path="/QrPayment" element={<QrPayment />} />
        <Route path="/ArifEqub" element={<ArifEqub />} />
        <Route path="/arif-e-invoice" element={<EInvoice />} />
        <Route path="/EInvoice" element={<Navigate to="/arif-e-invoice" replace />} />
        <Route path="/Hospitality" element={<Hospitality />} />
        <Route path="/Partners" element={<Partner />} />
        <Route path="/become-a-partner" element={<BecomeAPartner />} />
        <Route path="/Partner2" element={<Navigate to="/become-a-partner" replace />} />
        <Route path="/Partner3" element={<Navigate to="/become-a-partner" replace />} />
        <Route path="/Partner4" element={<Navigate to="/become-a-partner" replace />} />
        <Route path="/Partner5" element={<Navigate to="/become-a-partner" replace />} />
        <Route path="/Transportation" element={<Transportation />} />
        <Route path="/MerchantApp" element={<MerchantApp />} />
        <Route path="/become-a-merchant" element={<BecomeAMerchantSection />} />
        <Route path="/Merchant1" element={<Navigate to="/become-a-merchant" replace />} />
        <Route path="/PressRelease" element={<PressandRelesa />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Events" element={<Events />} />
        <Route path="/EventDetal1" element={<EventDetail />} />
        <Route path="/Jobs" element={<Jobs />} />
        <Route path="/Job/:id" element={<Job />} />
        <Route path="/Corporate" element={<Corporate />} />
        <Route path="/corporate1" element={<CorporateJob />} />
        <Route path="/Pagination" element={<Pagination />} />
        <Route path="/gatewayIntegration" element={<Integrate />} />
        <Route path="/CarParking" element={<CarParking />} />
        <Route
          path="/CompanyProfileViewer"
          element={<CompanyProfileViewer />}
        />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/Ecommerce" element={<Ecommerce />} />
        <Route path="/HealthCare" element={<HealthCare />} />
        <Route path="/Founders-Friday" element={<EventDetailFoundersFriday/>} />
        <Route path="/Founders-Friday-Event" element={<UpcomingEventPage/>} />
        <Route path="/Compliance" element={<Compliance/>}/>
      </Routes>
    </>
  );
}

export default App;
